import React from 'react'
import ServiceSlider from './ServiceSlider'

const ServicesSection = () => {
  return (
    <div className='container services-container'>
         <ServiceSlider/>
    </div>
  )
}

export default ServicesSection